<template>
  <div id="login">
    <div class="head">
      <div class="left"></div>
      <div class="right">
        <el-select v-model="value" placeholder="Select" style="width: 100px">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div>
    </div>

    <div class="content">
      <div
        class="tabs"
        :style="`--num:${formTabIndex};--size:${formTabData.length};`"
      >
        <div
          :class="`item ${formTabIndex == index ? 'index' : ''}`"
          @click="formTabChange(index)"
          v-for="(item, index) in formTabData"
          :key="item.id"
        >
          {{ item.name }}
        </div>
      </div>

      <el-form
        class="form"
        :model="form"
        label-width="0"
        ref="formRef"
        :rules="rules"
        style="max-width: 100%"
      >
        <el-form-item prop="user">
          <el-input
            v-model="form.user"
            placeholder="请输入账号"
            clearable
            size="large"
          />
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            v-model="form.password"
            placeholder="请输入密码"
            type="password"
            clearable
            size="large"
            @keydown.enter="login(formRef)"
          />
        </el-form-item>
        <div class="remember">
          <div class="left">
            <el-checkbox
              v-model="remember"
              label="下次自动登录"
              size="large"
              @change="rememberChange"
            />
          </div>
          <div></div>
        </div>
        <el-button type="primary" size="large" @click="login(formRef)"
          >登录</el-button
        >
      </el-form>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref, getCurrentInstance, onMounted } from "vue";
import md5 from "js-md5";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import { ElMessage } from "element-plus";
//获取公共方法
let { proxy } = getCurrentInstance();
//全局数据
let vuex = useStore();
// 路由实例，用于导航
const router = useRouter();
// 当前路由信息
const route = useRoute();
//语言数据
let options = [
  {
    value: 1,
    label: "简体中文",
  },
];
let value = ref(1);
//表单tab栏
let formTabData = [
  {
    id: 1,
    name: "账号登录",
  },
  // {
  //   id: 2,
  //   name: "短信登录",
  // },
];
//表单对象
let formRef = ref(null);
//校验规则
const rules = reactive({
  user: [{ required: true, message: "账号不能为空", trigger: "blur" }],
  password: [{ required: true, message: "密码不能为空", trigger: "blur" }],
});
//表单tab栏下标
let formTabIndex = ref(0);
//表单数据
let form = reactive({
  //账号
  user: ref(vuex.state.userInfo.name || ""),
  //密码
  password: ref(""),
});
//记住登录
let remember = ref(vuex.state.remember);
//页面渲染事件
onMounted(() => {
  if (route.query.loginAuto) loginAuto();
});
//表单tab下标切换
function formTabChange(index) {
  formTabIndex.value = index;
  console.log(formTabIndex);
}
//登录
function login(formEl) {
  if (!formEl) return;
  formEl.validate((valid) => {
    if (valid) {
      //登录接口
      proxy.$http
        .post("webapi/login", {
          name: form.user,
          passwd: md5(`mq${form.user}${form.password}`),
        })
        .then(({ data: res }) => {
          if (res.code == 0 && res.data.pages) {
            vuex.commit("setUser", res.data);
            vuex.commit("setTokenTime", Date.now());
            ElMessage({
              message: "登录成功",
              type: "success",
            });
            // 带有路径的对象
            router.push({ path: "/home" });
          } else {
            if (!res.data.pages) {
              ElMessage({
                message: "该账号没有任何权限，请联系管理员添加权限",
                type: "warning",
                grouping: true,
              });
            }
          }
        })
        .catch((err) => {
          console.log("请求失败");
        });
    }
  });
}
//自动登录
function loginAuto() {
  vuex.dispatch("loginAuto");
}
//记住登录变换
function rememberChange(e) {
  vuex.commit("setRemember", e);
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/login.scss";
</style>